import { richTextFieldActions } from 'components/shared/util/richTextField/actions/richTextField';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';
/** Hook that returns a function that can be used to upload a file */
export function useFileUpload() {
    const dispatch = useAppDispatch();
    const uploadAction = bindActionToPromise(dispatch, richTextFieldActions.richTextFieldAddAttachments);
    const uploadFile = (file) => uploadAction(file).then((result) => {
        return {
            link: result.data.link,
        };
    });
    return uploadFile;
}
